import React, { createContext, useState } from 'react';
import _ from 'lodash';

const PageContext = createContext();

const PageProvider = (props) => {
    // members tab state
    const [checked, setChecked] = useState([]);
    const [csvStudents, setCSVStudents] = useState([]);
    const [dialog, setDialog] = useState({
        open: false,
        message: '',
        description: '',
        variant: 'primary',
        actionButtonText: '',
        onAction: () => {},
    });
    const [cloningContentsDialog, setCloningContentsDialog] = useState({
        open: false,
        message: '',
        description: '',
        variant: 'primary',
        actionButtonText: '',
        onAction: () => {},
    });
    const [generatedIdList, setGeneratedIdList] = useState([]);
    const [memberFilters, setMemberFilters] = useState({
        open: false,
        sortKey: 'namea-z',
        filterKeys: [],
        searchInput: '',
    });

    // Members Tab only
    const [isSyncRosterLoading, setIsSyncRosterLoading] = useState(false);
    const [syncRosterDialog, setSyncRosterDialog] = useState({ open: false });

    const value = {
        checked,
        setChecked,
        csvStudents,
        setCSVStudents,
        dialog,
        setDialog,
        cloningContentsDialog,
        setCloningContentsDialog,
        generatedIdList,
        setGeneratedIdList,
        memberFilters,
        setMemberFilters,

        // Sync roster
        isSyncRosterLoading,
        setIsSyncRosterLoading,
        syncRosterDialog,
        setSyncRosterDialog,
    };

    return <PageContext.Provider value={value} {...props} />;
};

export { PageContext };
export default PageProvider;
